import { observer } from 'mobx-react';
import React, { useEffect, useState } from 'react';
import { useStores } from '../index';

const ActionStoreProjectChangeHandler: React.FC = observer(() => {
  const { actionsStore, dataStore } = useStores();
  const [oldProjectId, setOldProjectId] = useState<number | undefined>();

  useEffect(() => {
    if (actionsStore && actionsStore.selectionClear && oldProjectId !== dataStore.project?.id) {
      actionsStore.selectionClear();
    }

    setOldProjectId(dataStore.project?.id);
  }, [dataStore.project, actionsStore]);

  return null;
});

export default ActionStoreProjectChangeHandler;